import { render, staticRenderFns } from "./imcNinos5a19A.vue?vue&type=template&id=7ef4b19c&scoped=true"
import script from "./imcNinos5a19A.vue?vue&type=script&lang=js"
export * from "./imcNinos5a19A.vue?vue&type=script&lang=js"
import style0 from "./imcNinos5a19A.vue?vue&type=style&index=0&id=7ef4b19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef4b19c",
  null
  
)

export default component.exports